import React from "react";

import purpleTickIcon from "../../../assets/images/purple-tick.png";

import ModalHolder from "../../molecules/ModalHolder";

import { H3, P } from "../../atoms/Texts";

const CreateCaseScheduleSuccessModal = ({ closeModal, _case }) => {
  return (
    <ModalHolder width="60%" closeModal={closeModal}>
      <div className="py-40">
        <img src={purpleTickIcon} alt="" className="h-24 w-24 mx-auto mb-10" />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Meeting with {_case?.referral?.user?.firstName} Scheduled
        </H3>
        <P color="#7D7B96" className="text-center md:w-3/4 mx-auto mt-2 mb-6">
          We shall send a reminder to your email address
        </P>
      </div>
    </ModalHolder>
  );
};

export default CreateCaseScheduleSuccessModal;
